require('./mortgageRequestSimpleNoteRequestStep2.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
const { withRouter } = require('react-router-dom');
// @ helpers
const { FormattedText, formatText } = require('core/i18n').i18n;
//@ components
const DropdownAccounts = require('components/dropdownAccounts/dropdownAccounts');
const MortgageRequestSimpleNoteRequestCostWafer = require('components/mortgageRequest/mortgageRequestSimpleNote/mortgageRequestSimpleNoteRequest/mortgageRequestSimpleNoteRequestCostWafer/mortgageRequestSimpleNoteRequestCostWafer');
//@commons
const { LoadingSection } = require('commonsComponents/loadingSection');
// @ constants
const { ACCOUNT_INTERVENTION_OWNER } = require('constants/index');
const { ACCOUNTS_CODES: { CURRENT_ACCOUNT_CODE } } = require('constants/mortgageRequestAppraisalRequest')
const { BLOCKED_ACCOUNTS_SIMPLE_NOTE } = require('constants/operationCodesAccounts');
const { DATOS_VIV } = require('constants/mortgageRequestStates');

class MortgageRequestSimpleNoteRequestStep2 extends React.Component {
    constructor(props) {
        super(props);

        this.handleAccountChange = this.handleAccountChange.bind(this);
    }

    componentDidMount() {
        const { getBlockedAccounts,
            immAccounts, immEstates, immPayment,
            setTotalCost, immState, history } = this.props;
        const simpleNoteCount = immEstates.get('list').filter(item => !(item.get('notaSimplePropia'))).size;
        const simpleNoteCost = immPayment.get('simpleNoteCost');
        const accountsMap = immAccounts.get('byId');
        const accountsIndexes = this.getAccountsList(immAccounts.get('byOrder'), accountsMap);
        const currentState = immState.get('estado');
        const mortgageStateFlag = currentState !== DATOS_VIV;
        if(mortgageStateFlag){
            history.push('/myprofile/mortgage/simple-note');
        }

        if (!immAccounts.get('blockedAccountsSuccess')) {

            const accounts = accountsIndexes.map(id => immAccounts.getIn(['byId', id]));
            getBlockedAccounts(accounts, BLOCKED_ACCOUNTS_SIMPLE_NOTE);
        }

        setTotalCost(simpleNoteCount * simpleNoteCost);
    }

    componentWillUnmount() {
        const { resetBlockedAccounts } = this.props;

        resetBlockedAccounts();
    }

    getAccountsList(accounts, accountsMap) {
        return accounts.filter(accountId => {
            const accountHolder = accountsMap.getIn([accountId, 'interventionType']);
            const accountProduct = accountsMap.getIn([accountId, 'newProduct']);
            return accountHolder === ACCOUNT_INTERVENTION_OWNER && accountProduct === CURRENT_ACCOUNT_CODE // CUENTA CORRIENTE
        });
    }

    handleAccountChange(accountId) {
        const { immAccounts, setAccount } = this.props;
        if (!!accountId) {
            const immAccount = immAccounts.getIn(['byId', accountId]);
            setAccount(accountId, immAccount.getIn(['balance', 'amount']), immAccount.get('iban'));
        }
    }

    buildAccounts() {
        const {
            immSimpleNoteRequest,
            immAccounts
        } = this.props;
        const accountsMap = immAccounts.get('byId');
        const accountsIndexes = this.getAccountsList(immAccounts.get('byOrder'), accountsMap);
        const immStep = immSimpleNoteRequest.getIn(['steps', 1]);
        const accountId = immStep.get('accountId');
        const accountRequiredAlertVisible = immStep.get('accountIsDirty') && !accountId;
        const accountNoEnoughBalanceAlertVisible = immStep.get('accountIsDirty') && !(immStep.get('accountBalance') >= immStep.get('totalCost'));
        const errorMessage = accountRequiredAlertVisible ? formatText('mortgageRequestSimpleNoteRequest-step2RequiredFieldMessage') :
            formatText('mortgageRequestSimpleNoteRequest-step2NotEnoughBalanceMessage');
        const disclaimer = {
            warning: 'mortgageRequestSimpleNoteRequest-mortgageRequestSimpleNoteRequest_blockedAccountsWarning',
            important: 'mortgageRequestSimpleNoteRequest-mortgageRequestSimpleNoteRequest_blockedAccountsImportant'
        };
        const isBlockedAccountsLoading = immAccounts.get('blockedAccountsLoading');

        return !immAccounts.get('blockedAccountsLoading') ? (
            <DropdownAccounts
                blockedAccountsAll={immAccounts.get('blockedAccountsAll')}
                blockedAccountsIds={immAccounts.get('blockedAccountsIds')}
                disclaimer={disclaimer}
                label="mortgageRequestSimpleNoteRequest-step2Account"
                immAccounts={accountsMap}
                currentAccountId={accountId}
                accountsIndexes={accountsIndexes.toJS()}
                onAccountChange={this.handleAccountChange}
                error={accountRequiredAlertVisible || accountNoEnoughBalanceAlertVisible}
                errorMsg={errorMessage}
                loading={isBlockedAccountsLoading}
            />
        ) : <LoadingSection />;
    }

    render() {
        const {
            immEstates,
            immPayment,
            summaryDocumentation
        } = this.props;
        const simpleNoteCost = immPayment.get('simpleNoteCost');
        const accounts = this.buildAccounts();

        return (
            <div className="mortgage-request-simple-note-request-step-two">
                <header className="mortgage-request-simple-note-request-step-two__header">
                    <FormattedText value="mortgageRequestSimpleNoteRequest-step2Title" />
                </header>
                {accounts}
                <MortgageRequestSimpleNoteRequestCostWafer
                    immEstates={immEstates}
                    simpleNoteCost={simpleNoteCost}
                    infoText={formatText('mortgageRequestSimpleNoteRequest-step2CostText')}
                    summaryDocumentation={summaryDocumentation}
                />
            </div>
        );
    }
}

MortgageRequestSimpleNoteRequestStep2.propTypes = {
    getBlockedAccounts: PropTypes.func.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immState: PropTypes.object,
    immEstates: PropTypes.object.isRequired,
    immPayment: PropTypes.object.isRequired,
    immSimpleNoteRequest: PropTypes.object.isRequired,
    resetBlockedAccounts: PropTypes.func.isRequired,
    setAccount: PropTypes.func.isRequired,
    setTotalCost: PropTypes.func.isRequired,
    summaryDocumentation: PropTypes.object,
    history: PropTypes.object,
};

module.exports = withRouter(MortgageRequestSimpleNoteRequestStep2);
